<p8-layout-settings-page>
  <mat-card>
    <mat-card-title>
      <p8-layout-settings-header [titlePath]="['Gestion des demandes de consultation d\'archives']"
                                 [iconRacine]="'find_in_page'"></p8-layout-settings-header>
    </mat-card-title>
    <mat-card-content fxLayout="column">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
                     [(selectedIndex)]="selectedTabIndex"
                     [disableRipple]="true">
        <mat-tab>
          <ng-template mat-tab-label>
            Liste des demandes de consultation
          </ng-template>
          <div>
            <app-data-table
              [dataSource]="dsLoaning"
              [extraParams]="extraParams"
              [refreshButton]="false"
              [refreshIcone]="true"
              [filterDisplay]="true"
              [placeHolderFilter]="'Recherche de demandes de consultation'"
              [toolTipFilter]="'Recherche de demandes de consultation'"
              [flexAction]="5" [flexColumn]="90"
              [pageSize]="10" [pageSizesList]="[5,10,25]"
              [columns]="columns" [actions]="actions"
              [showFirstLastButtons]="true"
              [showLoader]="true">
            </app-data-table>
          </div>
        </mat-tab>
        <mat-tab #tab *ngFor="let loaning of selectedLoanings">
          <ng-template mat-tab-label>
            <span>{{loaning.reference}}</span>
            <span class="fill-space"></span>
            <button class="tab-close-button" mat-icon-button
                    matTooltip="fermer la demande"
                    (click)="closeLoaningTab($event, loaning)" data-cy="btn-list-loaning-close">
              <mat-icon style="font-size: 16px" color="primary" data-cy="icon-list-loaning-close">close</mat-icon>
            </button>
          </ng-template>
          <app-loaning-consultation [loaning]="loaning"
                                    [displayTitle]="false"
                                    [returnList]="false"></app-loaning-consultation>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</p8-layout-settings-page>
